﻿import urls from "./campaignUrls";
import contactUs from "./contactus";
import download from "./download";
import partnerName from "./partnername";

export default function enableFeatures(features, bannerId) {
	const messageId = bannerId;

	const requireParams = `&bannerId=${messageId}`;
	features.options.context += requireParams;
	const options = features.options;

	if (features.campaignUrls) {
		urls(features.campaignUrls, options.log);
	}

	contactUs(features.contactUs, options);
	download(features.download, options);

	if (features.partnerName) {
		partnerName(features.partnerName);
	}
};
